import { AddProductInCartButton } from '../buttons/addProductInCartButton/AddProductInCartButton';
import { DeleteProductFromCartButton } from './../buttons/deleteProductFromCartButton/DeleteProductFromCartButton';
import { DeleteProductButton } from '../buttons/deleteProductButton/DeleteProductButton';

import styles from './Modal.module.css';

export const Modal = ({
    show,
    handleClose,
    card,
    isAuthorized,
    addProductInCart,
    deletePurchasedProduct,
    cartList }) => {

    let newCartList = cartList?.map(function (cart) {
        return cart.id
    })

    return (
        <div className={show ? styles.modal + ' ' + styles.displayBlock : styles.modal + ' ' + styles.displayNone}
            onClick={handleClose}
        >
            <div className={styles.modalContent} onClick={event => event.stopPropagation()}>
                <div className={styles.buyContainer}>
                    <div >
                        <img src={card.url} className={styles.image} />
                    </div>
                    <div className={styles.descriptionContainer}>
                        <div className={styles.name}>{card.name}</div>
                        <div className={styles.contains}>
                            <b>Склад: </b>{card.description}
                        </div>

                        <div className={styles.containerPrice}>
                            <div className={styles.productPrice}>
                                {card.price} грн
                            </div>
                            <div className={styles.productWeight}>
                                {card.weight} г
                            </div>
                        </div>

                        <div className={styles.buttonsContainer}>

                            {newCartList?.includes(card.id) ?

                                <DeleteProductFromCartButton id={card.id}
                                    deletePurchasedProduct={deletePurchasedProduct} />
                                :
                                <AddProductInCartButton addProductInCart={addProductInCart}
                                    id={card.id} />
                            }

                            {
                                isAuthorized &&
                                <div className={styles.deleteButton}>
                                    <DeleteProductButton id={card.id} />
                                </div>

                            }
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};